import { render } from "./PrintHeaderDesign4.vue?vue&type=template&id=e42681dc&scoped=true"
import script from "./PrintHeaderDesign4.vue?vue&type=script&lang=js"
export * from "./PrintHeaderDesign4.vue?vue&type=script&lang=js"

import "./PrintHeaderDesign4.vue?vue&type=style&index=0&id=e42681dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e42681dc"]])

export default __exports__